module.exports = __webpack_public_path__ + "img/2.4202105d.png";